import config from '../config';

class Transition {
  constructor (gameContext) {
    this.g = gameContext;
    let g = this.g;
    // console.log('Constructor', this);

    this.bg = g.add.sprite(config.CENTER_X, config.CENTER_Y, 'transition-bg');
    this.bg.setVisible(false);
    this.bg.setActive(false);
    this.startY = config.CENTER_Y - (this.bg.height) * 1.5;
    this.endY = config.CENTER_Y + (this.bg.height) * 1.5;
  }
  in (cb) {
    let g = this.g;
    let bg = this.bg;

    bg.setVisible(true);
    bg.setActive(true);
    bg.setY(this.startY);

    g.tweens.add({
      targets: bg,
      duration: 400,
      y: config.CENTER_Y,
      onComplete: () => {
        if (cb) {
          cb();
        }
      }
    });
  }
  out (cb) {
    let g = this.g;
    let bg = this.bg;

    bg.setVisible(true);
    bg.setActive(true);
    bg.setY(config.CENTER_Y);

    g.tweens.add({
      targets: bg,
      duration: 400,
      y: this.endY,
      onComplete: () => {
        bg.setVisible(false);
        bg.setActive(false);
        if (cb) {
          cb();
        }
      }
    });
  }
}

export default Transition;
